module.exports = __webpack_public_path__ + "fonts/Flaticon.51740709.eot";